import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-curriculum-payment-success',
  templateUrl: './curriculum-payment-success.component.html',
  styleUrls: ['./curriculum-payment-success.component.scss']
})
export class CurriculumPaymentSuccessComponent implements OnInit {

  dataService: CurriculumService;
  guid: string;
  ShowFailureMessage: boolean;
  ShowInvoiceMessage: boolean;
  loading: boolean = true;

  constructor(
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.dataService = serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.guid = params.get('guid');

      this.dataService.GetRedirectModelFromProcessPaymentSuccess(this.guid).subscribe((model)=>{
        if (!model.Success){
          this.ShowFailureMessage = true;
          return;
        }
        else{
          this.ShowInvoiceMessage = true;
          var classID = model.ClassID;

           setTimeout(() => this.router.navigate([environment.rootPath + 'CurriculumView/' + classID]), 5000);
          ;
        }

        this.loading = false;

      });
    });
  }
}
